import { ApplicationState } from '@/store';
import React from 'react';
import { useSelector } from 'react-redux';
import HomeStudentStandart from './home';
import { HomeStudentWhiteLabel } from './HomeStudentWhiteLabel';

const HomeStudent: React.FC = () => {
    const { isWhiteLabel } = useSelector((state: ApplicationState) => ({
        isWhiteLabel: state.appOrganization.data.isWhiteLabel,
    }));

    if (isWhiteLabel) {
        return <HomeStudentWhiteLabel />;
    }

    return <HomeStudentStandart />;
};

export { HomeStudent };
